import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { FullPageSpinner } from '../ui/primitives';
import { useAuth } from './useAuth';

/**
 * Gate for every authenticated route.
 *
 * While `status === 'booting'` this renders a spinner and NOT the child. The
 * boot refresh is still deciding whether there is a session; rendering the app
 * first and correcting later would flash the shell on a dead session, and
 * redirecting first would flash /login on a live one.
 */
export function RequireAuth(): JSX.Element {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'booting') {
    return <FullPageSpinner label="Restoring session" />;
  }

  if (status === 'anonymous') {
    // `from` lets /login send the user back where they were aiming.
    // `replace` keeps the guarded URL out of history, so Back does not bounce.
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }

  return <Outlet />;
}
